import useCatalogCategoryNames from './useCatalogCategoryNames';

export default useCatalogCategoryNames;
